import React, { useState } from 'react';
import VerticalTimeline from '@jbhi-fi/lanyard-ui/components/VerticalTimeline';
import { VerticalTimelineContent } from '@jbhi-fi/lanyard-ui/components/VerticalTimeline/VerticalTimeline';
import { Accordion } from '@jbhi-fi/lanyard-ui/components/Accordion';
import NegativeIcon from '@jbhi-fi/lanyard-ui/components/Icons/Negative';
import PositiveIcon from '@jbhi-fi/lanyard-ui/components/Icons/Positive';
import { styles } from './TrackingHistory.css';
import Button from '@jbhi-fi/lanyard-ui/components/Button';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';
import { BaseContentSection } from '@jbhi-fi/apis/src/orderTrackingThemeApi/types';
import { MarkdownBlock } from '../../MarkdownBlock';
import { useTrackingContext } from '../../Tracking';

export interface TrackingHistoryProps {
  historyData: VerticalTimelineContent;
  helpMessaging?: BaseContentSection;
  carrierTrackingUrl?: string;
}

export const TrackingHistory = ({ historyData, helpMessaging, carrierTrackingUrl }: TrackingHistoryProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { tracker } = useTrackingContext();

  const handleToggleOpen = () => {
    tracker?.trackClick({
      label: 'orderTrackingPageAccordionExpand',
    });
    setIsOpen(!isOpen);
  };

  const onCarrierTrackingClick = () => {
    window.open(carrierTrackingUrl, '_blank');
  };

  const accordionContent = (
    <div className={styles.contentWrapper}>
      <VerticalTimeline content={historyData} data-testid="tracking-history-timeline" />
      {carrierTrackingUrl ? (
        <div className={styles.trackingInfo}>
          <Button
            type="secondary"
            label="View full tracking"
            icon={<Icon name="ExternalLink" />}
            iconPosition="right"
            classes={styles.trackingButton}
            data-testid="tracking-history-button"
            onClick={onCarrierTrackingClick}
          />
        </div>
      ) : null}
      {helpMessaging?.content ? (
        <div className={styles.helpMessaging}>
          <MarkdownBlock shouldLinkOpenInNewTab>{helpMessaging.content}</MarkdownBlock>
        </div>
      ) : null}
    </div>
  );

  return (
    <Accordion
      id="tracking-history-accordion"
      items={[
        {
          head: <span>Tracking history</span>,
          closeIcon: <NegativeIcon />,
          openIcon: <PositiveIcon />,
          content: accordionContent,
        },
      ]}
      accordionHeaderClassname={styles.accordionHeader({ isOpen })}
      accordionContentClassname={styles.accordionContent({ isOpen })}
      accordionItemClassname={styles.accordionItem}
      activeState={isOpen ? [0] : []}
      onActiveStateChange={handleToggleOpen}
    />
  );
};
